class Car {
	constructor(id, slug, carName, price, discountPercent, description) {
		this.id = id;
		this.slug = slug;
		this.carName = carName;
		this.price = price;
		this.discountPercent = discountPercent;
		this.description = description;
	}

	toPlainObj() {
		return {
			id: this.id,
			slug: this.slug,
			carName: this.carName,
			price: this.price,
			discountPercent: this.discountPercent,
			description: this.description
		};
	}
}

export default function CarBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withSlug: function (slug) {
			this.slug = slug;
			return this;
		},
		withCarName: function (carName) {
			this.carName = carName;
			return this;
		},
		withPrice: function (price) {
			this.price = price;
			return this;
		},
		withDiscountPercent: function (discountPercent) {
			this.discountPercent = discountPercent;
			return this;
		},
		withDescription: function (description) {
			this.description = description;
			return this;
		},
		build: function () {
			return new Car(this.id, 
				this.slug, 
				this.carName, 
				this.price, 
				this.discountPercent, 
				this.description
			);
		}
	};
}

export function CreateCarModel(car) {
	return new CarBuilder()
		.withId(car.id)
		.withSlug(car.slug)
		.withCarName(car.car_name)
		.withPrice(car.price)
		.withDiscountPercent(car.discount_percent)
		.withDescription(car.description)
		.build().toPlainObj();
}
